<template>
  <v-container fluid grid-list-md>
    <v-card class="mx-auto">
      <v-toolbar color="white darken-4">
        <v-toolbar-title>Pagamento {{ payment.uuid }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <!--v-btn icon>
            <v-icon>print</v-icon>
          </v-btn-->
      </v-toolbar>
      <payment-content />
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Payment",
  computed: {
    ...mapGetters({
      payment: "payments/payment",
    }),
  },
  created() {
    this.$store.dispatch("payments/get");
  },
  components: {
    PaymentContent: () => import("@/components/payments/PaymentContent.vue"),
  },
};
</script>
